import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { TranslateService } from '@ngx-translate/core';
import { AppRoutes } from 'src/app/app-routes';
import { SubmittableForm } from 'src/app/models/base/submittable-form.base';
import { RegisterService } from 'src/app/services/register-service/register.service';
import { RouteParams } from '../reset-password/reset-password.component';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-verify-code',
  templateUrl: './verify-code.component.html',
  styleUrls: ['./verify-code.component.scss']
})
export class VerifyCodeComponent extends SubmittableForm implements OnInit {

  faBack = faArrowLeft;
  AppRoutes = AppRoutes;

  userNumber: number | undefined;

  constructor(
    translateService: TranslateService, 
    private registerService: RegisterService, 
    private router: Router, 
    private activeRoute: ActivatedRoute, 
    private spinner: NgxSpinnerService
  ) 
  {
    super(translateService);
  }

  override form = new FormGroup({
    verifyCode: new FormControl('', {
      validators: [Validators.required, Validators.minLength(6)]
    })
  });

  ngOnInit(): void
  { 
    this.userNumber = this.activeRoute.snapshot.params[RouteParams.PHONE];
  }

  getPhoneNo(): string
  {
    return this.userNumber ? this.userNumber.toString() : 'unknown number';
  }

  async onCodeSubmitted()
  {
    this.spinner.show();

    const loginID = `${this.userNumber}`;
    return super.onConfirm(
      () => this.registerService.sendVerifyCode(loginID, this.form.value?.verifyCode as string),
      {
        onSuccess: () => {
          this.spinner.hide();

          this.router.navigate([AppRoutes.NewPassword, loginID, this.form.value.verifyCode]);
        },
        onError: () => {
          this.spinner.hide();
        }
      }
    );
  }

  shouldAllowRequest(): boolean
  {
    return this.form.controls.verifyCode.invalid;
  }
}
